import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 React components
import Sidenav from "../src/components/Sidenav";

// Material Dashboard 2 React themes
import theme from "../src/assets/theme";
import themeDark from "../src/assets/theme-dark";

// RTL plugins
import createCache from "@emotion/cache";

// Material Dashboard 2 React contexts
import {
  useMaterialUIController,
  setMiniSidenav,
} from "../src/context";

// Images
import logoDataMuni from "../src/assets/images/logos/logo_datamuni_horizontal.png";
import logoDataMuniIcono from "../src/assets/images/logos/logo_datamuni_icono.png";

// Componentes
import Login from "./components/authentication/Login";
import Registrarme from "./components/authentication/Registrarme";
import Confirmacion from "./components/authentication/Confirmacion";
import ConfirmacionIngreso from "./components/authentication/ConfirmacionIngreso";
import RecuperarPass from "./components/authentication/RecuperarPass";
import ConfirmacionRecuperoPass from "./components/authentication/ConfirmacionRecuperoPass";
import PerfilAdd from "./components/authentication/Perfil/PerfilAdd";
import PerfilEdit from "./components/authentication/Perfil/PerfilEdit";
import Perfiles from "./components/authentication/Perfil/Perfiles";
import SessionChecker from "./SessionChecker";
import ConfirmarCuentaxToken from "./components/authentication/ConfirmarCuentaxToken";
import ConfirmacionActivacionCuenta from "./components/authentication/ConfirmacionActivacionCuenta";
import Permisos from "./components/authentication/Permisos";
import CloseSession from "./components/authentication/CloseSession";
import UsuarioEdit from "./components/authentication/Usuario/UsuarioEdit";
import UsuarioList from "./components/authentication/Usuario/UsuarioList";
import CambiarContrasenia from "./components/authentication/CambiarContrasenia";
import UsuarioParametros from "./components/authentication/Usuario/UsuarioParametros";

import { Eject, KeyFill, Person } from "react-bootstrap-icons";
import { Close, CalendarMonth, ManageAccounts, FileDownloadSharp, Business, People, Phone, EmojiPeople, Build, AccountBalance, DocumentScanner, PeopleTwoTone, PriorityHigh, Gavel, Assignment, Flag, Event, Balance, History, Sms, Campaign, FactCheck, ManageSearch, Calculate } from "@mui/icons-material";

import { getData, postData } from "./components/Utils/Http/api";
import SujetoContactoTipoAdd from "./components/Pages/Sujeto/SujetoContactoTipo/SujetoContactoTipoAdd";
import SujetoContactoTipoEdit from "./components/Pages/Sujeto/SujetoContactoTipo/SujetoContactoTipoEdit";
import SujetoContactoTipoList from "./components/Pages/Sujeto/SujetoContactoTipo/SujetoContactoTipoListar";
import SujetoContactoOrigenAdd from "./components/Pages/Sujeto/SujetoContactoOrigen/SujetoContactoOrigenAdd";
import SujetoContactoOrigenEdit from "./components/Pages/Sujeto/SujetoContactoOrigen/SujetoContactoOrigenEdit";
import SujetoContactoOrigenList from "./components/Pages/Sujeto/SujetoContactoOrigen/SujetoContactoOrigenListar";
import SujetoContactoPrioridadAdd from "./components/Pages/Sujeto/SujetoContactoPrioridad/SujetoContactoPrioridadAdd";
import SujetoContactoPrioridadEdit from "./components/Pages/Sujeto/SujetoContactoPrioridad/SujetoContactoPrioridadEdit";
import SujetoContactoPrioridadList from "./components/Pages/Sujeto/SujetoContactoPrioridad/SujetoContactoPrioridadListar";
import MensajeAdd from "./components/Pages/Mensaje/MensajeAdd";
import MensajeEdit from "./components/Pages/Mensaje/MensajeEdit";
import MensajeList from "./components/Pages/Mensaje/MensajeListar";
import PuntajeReglaListar from "./components/Pages/PuntajeRegla/PuntajeReglaListar";
import InformeDisparadorListar from "./components/Pages/InformeDisparador/InformeDisparadorListar";
import { fetchPerfilActual } from "./components/Utils/PerfilActual";
import MotivoCualitativoAdd from "./components/Pages/MotivoCualitativo/MotivoCualitativoAdd";
import MotivoCualitativoEdit from "./components/Pages/MotivoCualitativo/MotivoCualitativoEdit";
import MotivoCualitativoList from "./components/Pages/MotivoCualitativo/MotivoCualitativoListar";
import CalendarioGestionAdd from "./components/Pages/CalendarioGestion/CalendarioGestionAdd";
import CalendarioGestionEdit from "./components/Pages/CalendarioGestion/CalendarioGestionEdit";
import CalendarioGestionListar from "./components/Pages/CalendarioGestion/CalendarioGestionListar";
import SujetoAdd from "./components/Pages/Sujeto/SujetoAdd";
import SujetoEdit from "./components/Pages/Sujeto/SujetoEdit";
import SujetoList from "./components/Pages/Sujeto/SujetoListar";
import OrganismoList from "./components/Pages/Organismo/OrganismoListar";
import OrganismoAdd from "./components/Pages/Organismo/OrganismoAdd";
import OrganismoEdit from "./components/Pages/Organismo/OrganismoEdit";
import Configurator from "./components/layauots/Configurator";
import SujetoTipoIdentificacionList from "./components/Pages/Organismo/SujetoTipoIdentificacion/SujetoTipoIdentificacionList";
import SujetoTipoIdentificacionAdd from "./components/Pages/Organismo/SujetoTipoIdentificacion/SujetoTipoIdentificacionAdd";
import SujetoTipoIdentificacionEdit from "./components/Pages/Organismo/SujetoTipoIdentificacion/SujetoTipoIdentificacionEdit";
import ImportarArchivo from "./components/Pages/Archivos/ImportarArchivo";
import CasosList from "./components/Pages/Casos/CasosList";
import HistorialCasosListar from "./components/Pages/Casos/HistorialCasosListar";
import CasosCualitativosList from "./components/Pages/Casos/CasosCualitativosList";
import CasoCualitativoEstadoListar from "./components/Pages/CasoCualitativoEstado/CasoCualitativoEstadoListar";
import CasoCualitativoEventoTipoListar from "./components/Pages/CasoCualitativoEventoTipo/CasoCualitativoEventoTipoListar";
import CasoEtapaListar from "./components/Pages/CasoEtapa/CasoEtapaListar";
import CasoEstadoListar from "./components/Pages/CasoEstado/CasoEstadoListar";
import CasoEventoTipoListar from "./components/Pages/CasoEventoTipo/CasoEventoTipoListar";
import JudEstadoListar from "./components/Pages/JudEstado/JudEstadoListar";
import JudEventoTipoListar from "./components/Pages/JudEventoTipo/JudEventoTipoListar";
import JudEventoRestriccionListar from "./components/Pages/JudEventoRestriccion/JudEventoRestriccionListar";
import JudCasoListar from "./components/Pages/JudCaso/JudCasoListar";
import DashGraphs from "./components/Pages/Dashboard/DashGraphs";
import BusquedaCasoLogListar from "./components/Pages/BusquedaCasoLog/BusquedaCasoLogListar";
import Ejemplos3DGraphs from "./components/Pages/Dashboard/Ejemplos3DGraphs";
import PivotTableChartExample from "./components/Pages/Dashboard/PivotTableChartExample";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction, sidenavColor, darkMode } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("isLoggedIn") === "true");
  const [shouldReload, setShouldReload] = useState(false);
  const [routesVisible, setRoutesVisible] = useState([]);
  const [routebydatabase, setRoutebydatabase] = useState([]);

  const handleCloseSession = () => {
    localStorage.setItem("isRegister", "false");
    localStorage.setItem("isLoggedIn", "false");
    localStorage.setItem("idPerfil", "0");
  };

  let routesnew = [
    { type: "title", name: "Gestion de Casos", key: "casos", icon: <Gavel />, visible: false, codigoPermiso: 300, incluyePublico: true },
    { type: "collapse", name: "Gestion Pre-Judicial", key: "listarcasos", route: "/CasosList", icon: <Phone />, component: <CasosList />, visible: false, codigoPermiso: 301 },
    // Calendario de Gestores: público, lo ve todo usuario (editarlo depende de la casilla del perfil, que valida el backend).
    { type: "collapse", name: "Calendario de Gestores", key: "calendariogestion", route: "/CalendarioGestionListar", icon: <CalendarMonth />, component: <CalendarioGestionListar />, visible: false, paraTodos: true },
    { type: "collapse", name: "Gestion Judicial", key: "listarcasosjudiciales", route: "/JudCasoListar", icon: <Balance />, component: <JudCasoListar />, visible: false, codigoPermiso: 302 },
    { type: "collapse", name: "Gestion de Casos Cualitativos", key: "listarcasoscualitativos", route: "/CasosCualitativosList", icon: <FactCheck />, component: <CasosCualitativosList />, visible: false, codigoPermiso: 308 },
    { type: "collapse", name: "Historial de Casos", key: "historialcasos", route: "/HistorialCasos", icon: <History />, component: <HistorialCasosListar />, visible: false, codigoPermiso: 307 },
    { type: "title", name: "Sujetos", key: "sujeto", icon: <People />, visible: false, codigoPermiso: 100 },
    { type: "collapse", name: "Sujetos", key: "sujetos", route: "/SujetoList", icon: <People />, component: <SujetoList />, visible: false, codigoPermiso: 103 },
    { type: "collapse", name: "Importar Sujetos - Casos", key: "importar_sujetos", route: "/ImportarArchivo", icon: <PeopleTwoTone />, component: <ImportarArchivo />, visible: false, codigoPermiso: 104 },
    { type: "title", name: "Configuraciones", key: "organismos", icon: <AccountBalance />, visible: false, codigoPermiso: 200 },
    { type: "collapse", name: "Organismos", key: "organismos", route: "/OrganismoList", icon: <AccountBalance />, component: <OrganismoList />, visible: false, codigoPermiso: 201 },
    { type: "collapse", name: "Tipo de Contactos", key: "tipocontacto", route: "/SujetoContactoTipoList", icon: <Phone />, component: <SujetoContactoTipoList />, visible: false, codigoPermiso: 202 },
    { type: "collapse", name: "Origenes de Contacto", key: "origencontacto", route: "/SujetoContactoOrigenList", icon: <EmojiPeople />, component: <SujetoContactoOrigenList />, visible: false, codigoPermiso: 203 },
    { type: "collapse", name: "Prioridades de Contacto", key: "prioridadcontacto", route: "/SujetoContactoPrioridadList", icon: <PriorityHigh />, component: <SujetoContactoPrioridadList />, visible: false, codigoPermiso: 205 },
    { type: "collapse", name: "Tipo de Identificacion", key: "tipoidentificacion", route: "/SujetoTipoIdentificacionList", icon: <DocumentScanner />, component: <SujetoTipoIdentificacionList />, visible: false, codigoPermiso: 204 },
    { type: "collapse", name: "Instancias del Caso", key: "casoetapa", route: "/CasoEtapaListar", icon: <Assignment />, component: <CasoEtapaListar />, visible: false, codigoPermiso: 206 },
    { type: "collapse", name: "Mensajes", key: "mensajes", route: "/MensajeList", icon: <Sms />, component: <MensajeList />, visible: false, codigoPermiso: 209 },
    { type: "collapse", name: "Motivos Campaña Cualitativa", key: "motivocualitativo", route: "/MotivoCualitativoList", icon: <Campaign />, component: <MotivoCualitativoList />, visible: false, codigoPermiso: 210 },
    { type: "title", name: "Configuraciones Pre-Judicial", key: "configuraciones_prejudiciales", icon: <AccountBalance />, visible: false, codigoPermiso: 240, incluyeDisparador: true },
    { type: "collapse", name: "Estados de la Gestion", key: "casoestado", route: "/CasoEstadoListar", icon: <Flag />, component: <CasoEstadoListar />, visible: false, codigoPermiso: 207 },
    { type: "collapse", name: "Tipos de Evento", key: "casoeventotipo", route: "/CasoEventoTipoListar", icon: <Event />, component: <CasoEventoTipoListar />, visible: false, codigoPermiso: 208 },
    // Disparador Automático de Gestiones: fuera de Perfiles y Permisos. Lo habilita la casilla del perfil "Puede definir la
    // modalidad de gestión de los usuarios" y el backend la vuelve a validar en cada llamada.
    { type: "collapse", name: "Reglas de Puntaje - Disparador", key: "puntajeregla", route: "/PuntajeReglaListar", icon: <Calculate />, component: <PuntajeReglaListar />, visible: false, soloPorDisparador: true },
    { type: "title", name: "Configuraciones Judicial", key: "configuraciones_judiciales", icon: <AccountBalance />, visible: false, codigoPermiso: 280 },
    { type: "collapse", name: "Estados Judiciales", key: "judestado", route: "/JudEstadoListar", icon: <Flag />, component: <JudEstadoListar />, visible: false, codigoPermiso: 281 },
    { type: "collapse", name: "Tipos de Evento Judicial", key: "judeventotipo", route: "/JudEventoTipoListar", icon: <Event />, component: <JudEventoTipoListar />, visible: false, codigoPermiso: 282 },
    { type: "collapse", name: "Restricciones de Eventos", key: "judeventorestriccion", route: "/JudEventoRestriccionListar", icon: <Build />, component: <JudEventoRestriccionListar />, visible: false, codigoPermiso: 283 },
    { type: "title", name: "Configuraciones Casos Cualitativos", key: "configuraciones_cualitativas", icon: <FactCheck />, visible: false, codigoPermiso: 320 },
    { type: "collapse", name: "Estados de la Gestion", key: "casocualitativoestado", route: "/CasoCualitativoEstadoListar", icon: <Flag />, component: <CasoCualitativoEstadoListar />, visible: false, codigoPermiso: 321 },
    { type: "collapse", name: "Tipos de Evento", key: "casocualitativoeventotipo", route: "/CasoCualitativoEventoTipoListar", icon: <Event />, component: <CasoCualitativoEventoTipoListar />, visible: false, codigoPermiso: 322 },

    { type: "title", name: "Estadisticas", key: "auditoria", icon: <FileDownloadSharp />, visible: true, codigoPermiso: 600, incluyeDisparador: true },
    { type: "collapse", name: "Analisis e Informes", key: "moduloBI", route: "/DashGraphs", icon: <Business />, component: <DashGraphs />, visible: false, codigoPermiso: 603 },
    // Disparador: igual que Reglas de Puntaje, lo habilita la casilla del perfil y no Perfiles y Permisos.
    { type: "collapse", name: "Informe de Gestión - Disparador", key: "informedisparador", route: "/InformeDisparador", icon: <FactCheck />, component: <InformeDisparadorListar />, visible: false, soloPorDisparador: true },
    // Fuera de Perfiles y Permisos: el backend decide por correo (BusquedaCasoLogAcceso) y la pantalla recibe 403 si no corresponde.
    { type: "collapse", name: "Busquedas de Casos", key: "busquedacasolog", route: "/BusquedaCasoLogListar", icon: <ManageSearch />, component: <BusquedaCasoLogListar />, visible: false, soloPorCorreo: true },

    { type: "title", name: "Seguridad", key: "seguridad", icon: <KeyFill />, visible: true, codigoPermiso: 400 },
    { type: "collapse", name: "Usuarios", key: "usuarios", route: "/Usuarios", icon: <ManageAccounts />, component: <UsuarioList />, visible: false, codigoPermiso: 401 },
    { type: "collapse", name: "Perfiles", key: "perfiles", route: "/Perfiles", icon: <Person />, component: <Perfiles />, visible: false, codigoPermiso: 402 },
    { type: "collapse", name: "ChangePassword", key: "changepassword", route: "/CambiarContrasenia", icon: <KeyFill />, component: <CambiarContrasenia />, visible: true, codigoPermiso: 404 },
    { type: "collapse", name: "Cerrar Sesion", key: "closesession", route: "/CloseSession", icon: <Close />, component: <CloseSession handleCloseSession={handleCloseSession} />, visible: true, codigoPermiso: 999 },
  ];

  useEffect(() => {
    localStorage.setItem("isLoggedIn", isLoggedIn);
  }, [isLoggedIn]);

  const GetPermisos = async () => {
    try {
      const reqPermisosxPerfil = {
        idperfil: localStorage.getItem("idPerfil"),
        idusuario: localStorage.getItem("iduserlogueado"),
      };
      const response = await postData(`/PerfilxPermiso`, reqPermisosxPerfil);
      const permisosBaseDatos = response.value || [];

      // Pantallas fuera de Perfiles y Permisos: las habilita el backend según el correo del usuario. Si la consulta falla,
      // no se muestran.
      let accesoPorCorreo = false;
      try {
        const acceso = await getData("/BusquedaCasoLogAcceso");
        accesoPorCorreo = acceso?.value?.permitido === true;
      } catch (error) {
        accesoPorCorreo = false;
      }

      // Disparador: lo ven los perfiles con la casilla de gestionarlo. Si la consulta falla, no se muestra.
      let puedeGestionarDisparador = false;
      try {
        const perfil = await fetchPerfilActual();
        puedeGestionarDisparador = perfil.puedeGestionarDisparador === true;
      } catch (error) {
        puedeGestionarDisparador = false;
      }

      const updatedRoutes = routesnew.map(route => {
        // Pantallas públicas (como el Calendario de Gestores) y el título que las agrupa: las ve todo usuario.
        if (route.paraTodos || route.incluyePublico) {
          route.visible = true;
          return route;
        }
        if (route.soloPorCorreo) {
          route.visible = accesoPorCorreo;
          return route;
        }
        if (route.soloPorDisparador) {
          route.visible = puedeGestionarDisparador;
          return route;
        }
        // Un título que agrupa pantallas del Disparador también se muestra a quien tiene la casilla aunque no tenga el permiso del
        // título: si no, esas pantallas quedarían colgadas del título de otro grupo.
        if (route.incluyeDisparador && puedeGestionarDisparador) {
          route.visible = true;
          return route;
        }
        const permisoEncontrado = permisosBaseDatos.find(p => p.codigoPermiso === route.codigoPermiso);
        if (permisoEncontrado || route.codigoPermiso === 404 || route.codigoPermiso === 999) {
          route.visible = true;
        } else {
          route.visible = false;
        }
        return route;
      });
      return updatedRoutes;
    } catch (error) {
      console.error("Error GetPermisos:", error);
      return [];
    }
  };

  const navigate = useNavigate();

  // Cache RTL
  useMemo(() => {
    const cacheRtl = createCache({ key: "rtl" });
    setRtlCache(cacheRtl);
  }, []);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleLogin = async () => {
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("isRegister", "false");
    localStorage.setItem("isActivarCuenta", "false");
    localStorage.setItem("isForgotPassword", "false");
    setIsLoggedIn(true);
    setShouldReload(true);
    navigate("/");
  };

  useEffect(() => {
    const fetchAndUpdateRoutes = async () => {
      if (!isLoggedIn) return;
      const routesDb = await GetPermisos();
      setRoutebydatabase(routesDb);
      setRoutesVisible(routesDb.filter(r => r.visible));
      setShouldReload(false);
    };
    fetchAndUpdateRoutes();
  }, [isLoggedIn, shouldReload]);

  useEffect(() => {
    document.body.setAttribute("dir", direction.tostrin);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map(route => {
      if (route.collapse) return getRoutes(route.collapse);
      if (route.route) return <Route path={route.route} element={route.component} key={route.key} />;
      return null;
    });

  return (
    <>
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        <CssBaseline />
        <Configurator />
        {isLoggedIn && <SessionChecker />}

        <Routes>
          {/* Rutas privadas */}
          {isLoggedIn && getRoutes(routesVisible)}
          {isLoggedIn && <Route path="/" element={<ConfirmacionIngreso />} />}

          {/* Rutas públicas */}
          <Route path="/Login" element={<Login handleLogin={handleLogin} />} />
          <Route path="/" element={<Login handleLogin={handleLogin} />} />
          <Route path="/Registrarme" element={<Registrarme />} />
          <Route path="/RecuperarPass" element={<RecuperarPass />} />
          <Route path="/ConfirmarCuentaXToken" element={<ConfirmarCuentaxToken />} />
          <Route path="/ActivarCuenta" element={<ConfirmarCuentaxToken />} />
          <Route path="/Confirmacion" element={<Confirmacion />} />
          <Route path="/ConfirmacionIngreso" element={<ConfirmacionIngreso />} />
          <Route path="/ConfirmacionActivacionCuenta" element={<ConfirmacionActivacionCuenta />} />
          <Route path="/RecoveryPass" element={<ConfirmacionRecuperoPass />} />
          <Route path="/Perfil/PerfilAdd" element={<PerfilAdd />} />
          <Route path="/Perfil/PerfilEdit/:id" element={<PerfilEdit />} />
          <Route path="/Perfil/Perfiles" element={<Perfiles />} />
          <Route path="/PerfilesVolver" element={<Perfiles />} />

          <Route path="/Permisos/:id" element={<Permisos />} />
          <Route path="/CloseSession" element={<CloseSession />} />
          <Route path="/UsuarioEdit/:id" element={<UsuarioEdit />} />
          <Route path="/Usuarios" element={<UsuarioList />} />
          <Route path="/UsuarioVolver" element={<UsuarioList />} />
          <Route path="/UsuarioParametros/:id" element={<UsuarioParametros />} />
          <Route path="/CambiarContrasenia" element={<CambiarContrasenia />} />
          <Route path="/RecoveryPassInfo" element={<ConfirmacionRecuperoPass />} />
          <Route path="/SujetoContactoTipoAdd" element={<SujetoContactoTipoAdd />} />
          <Route path="/SujetoContactoTipoEdit/:id" element={<SujetoContactoTipoEdit />} />
          <Route path="/SujetoContactoTipoList" element={<SujetoContactoTipoList />} />
          <Route path="/SujetoContactoOrigenAdd" element={<SujetoContactoOrigenAdd />} />
          <Route path="/SujetoContactoOrigenEdit/:id" element={<SujetoContactoOrigenEdit />} />
          <Route path="/SujetoContactoOrigenList" element={<SujetoContactoOrigenList />} />
          <Route path="/SujetoContactoPrioridadAdd" element={<SujetoContactoPrioridadAdd />} />
          <Route path="/SujetoContactoPrioridadEdit/:id" element={<SujetoContactoPrioridadEdit />} />
          <Route path="/SujetoContactoPrioridadList" element={<SujetoContactoPrioridadList />} />
          <Route path="/MensajeAdd" element={<MensajeAdd />} />
          <Route path="/MensajeEdit/:id" element={<MensajeEdit />} />
          <Route path="/MensajeList" element={<MensajeList />} />
          <Route path="/MotivoCualitativoAdd" element={<MotivoCualitativoAdd />} />
          <Route path="/MotivoCualitativoEdit/:id" element={<MotivoCualitativoEdit />} />
          <Route path="/MotivoCualitativoList" element={<MotivoCualitativoList />} />
          <Route path="/CalendarioGestionAdd" element={<CalendarioGestionAdd />} />
          <Route path="/CalendarioGestionEdit/:id" element={<CalendarioGestionEdit />} />
          <Route path="/SujetoAdd" element={<SujetoAdd />} />
          <Route path="/SujetoEdit/:id" element={<SujetoEdit />} />
          <Route path="/SujetoList" element={<SujetoList />} />
          <Route path="/OrganismoAdd" element={<OrganismoAdd />} />
          <Route path="/OrganismoEdit/:id" element={<OrganismoEdit />} />
          <Route path="/OrganismoList" element={<OrganismoList />} />
          <Route path="/SujetoTipoIdentificacionList" element={<SujetoTipoIdentificacionList />} />
          <Route path="/SujetoTipoIdentificacionAdd" element={<SujetoTipoIdentificacionAdd />} />
          <Route path="/SujetoTipoIdentificacionEdit/:id" element={<SujetoTipoIdentificacionEdit />} />
          <Route path="/ImportarArchivo" element={<ImportarArchivo />} />
          <Route path="/CasosList" element={<CasosList />} />
          <Route path="/HistorialCasos" element={<HistorialCasosListar />} />
          <Route path="/CasosCualitativosList" element={<CasosCualitativosList />} />
          <Route path="/CasoCualitativoEstadoListar" element={<CasoCualitativoEstadoListar />} />
          <Route path="/CasoCualitativoEventoTipoListar" element={<CasoCualitativoEventoTipoListar />} />
          <Route path="/JudEstadoListar" element={<JudEstadoListar />} />
          <Route path="/JudEventoTipoListar" element={<JudEventoTipoListar />} />
          <Route path="/JudEventoRestriccionListar" element={<JudEventoRestriccionListar />} />
          <Route path="/JudCasoListar" element={<JudCasoListar />} />
          <Route path="/DashGraphs" element={<DashGraphs />} />
          <Route path="/BusquedaCasoLogListar" element={<BusquedaCasoLogListar />} />
          <Route path="/PuntajeReglaListar" element={<PuntajeReglaListar />} />
          <Route path="/InformeDisparador" element={<InformeDisparadorListar />} />
          <Route path="/DashGraphsEj" element={<Ejemplos3DGraphs />} />
          <Route path="/PivotTableChartExample" element={<PivotTableChartExample />} />
          

        </Routes>
        {isLoggedIn && !["/Login", "/Registrarme", "/ConfirmarCuentaXToken", "/RecoveryPassInfo", "/RecoveryPass"].includes(pathname) && (
          <Sidenav
            color={sidenavColor}
            brand={logoDataMuni}
            brandIcon={logoDataMuniIcono}
            brandName="Data Muni"
            routes={routesVisible}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
            visible={false}
          />
        )}
      </ThemeProvider>
    </>
  );
}
